<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Withdraw</p>
      <b-button type="button" icon-left="close" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <p class="mb-5">Submit a request to withdraw your funds. Please check that your wallet corresponds with the crypto. Withdrawal takes up to 48 hours.</p>
      <b-field v-if="loggedIn" label="Wallet" class="mb-0">
        <b-select expanded v-model="walletType">
          <option v-for="(wallet, index) in wallets" :value="wallet.type" :key="index">
            {{ wallet.type }}
          </option>
        </b-select>
      </b-field>
      <small v-if="getWalletBalance">Balance: {{ getWalletBalance.usableBalance }}</small>
      <b-field class="mt-2" label="Address">
        <b-input v-model="address"/>
      </b-field>
      <b-field class="mt-2" label="Amount">
        <b-input v-model="amount"/>
      </b-field>
      <b-button @click="withdraw()" type="is-success">Submit</b-button>
    </section>
  </div>
</template>
<script>
import ApiService from '../common/api.service'
export default {
  data() {
    return {
      walletType: "btc",
      address: null,
      amount: null
    }
  },
  methods: {
    async withdraw() {
      await ApiService.post("/user/withdraw", { type: this.walletType, address: this.address, amount: this.amount })
       this.$buefy.toast.open({
        type: "is-success",
        message: "Your request has been received"
      })
    }
  },
  computed: {
    wallets() {
      return this.$store.state.user.wallets
    },
    loggedIn() {
      return this.$store.state.user.loggedIn
    },
    getWalletBalance() {
      return this._.find(this.wallets, { type: this.walletType })
    },
  }
}
</script>
